import PropTypes from 'prop-types';
import React from 'react';
import { Button, Wrapper, Menu, MenuItem } from 'react-aria-menubutton';

export default class MenuButton extends React.Component {
    static displayName = 'MenuButton';

    static propTypes = {
        children: PropTypes.node.isRequired,
        disabled: PropTypes.bool,
        ariaLabelledBy: PropTypes.string.isRequired,
        items: PropTypes.array.isRequired,
        onSelection: PropTypes.func.isRequired,
        renderItem: PropTypes.func.isRequired,
        value: PropTypes.any,
    };

    wrap(child, index) {
        if (child.key == null) {
            throw new Error('renderItem must return keyed elements');
        }

        return (
            <li key={child.key} className="react-dropdown-menu-item-wrapper">
                <MenuItem
                    className="react-dropdown-menu-item"
                    value={child.key}
                >
                    {child}
                </MenuItem>
            </li>
        );
    }

    render() {
        const { items, value, disabled = false, ariaLabelledBy } = this.props;

        const possibleValues = items.map(this.props.renderItem);
        const itemElements = possibleValues.map(this.wrap.bind(this));

        let content = this.props.children;

        if (value != null) {
            // Keys are always converted to strings :/
            const valueElement = possibleValues.find(
                i => String(i.key) === String(value)
            );

            if (valueElement != null) {
                content = React.cloneElement(valueElement);
            }
        }

        const valueId = `${ariaLabelledBy}Value`;

        if (disabled) {
            return <button disabled>{content}</button>;
        }

        return (
            <Wrapper
                className="react-dropdown"
                onSelection={this.props.onSelection}
            >
                <Button
                    className="react-dropdown-button"
                    aria-labelledby={`${ariaLabelledBy} ${valueId}`}
                >
                    <span id={valueId}>{content}</span>
                </Button>
                <Menu className="react-dropdown-menu">
                    <ul>{itemElements}</ul>
                </Menu>
            </Wrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/menu_button.ui.jsx